module.exports = __webpack_public_path__ + "static/media/search.adc0e520.svg";